import React from "react";
import s from '../componentsStlyes/Paginado.module.css'


export default function Paginado ({recipes, currentRecipes, numberBotton}){
    const paginas = []
    for (let i = 1; i < Math.ceil(recipes.length/currentRecipes) ; i++) {
        paginas.push(i)
    }

    return(
            <div >
                <nav >
                    {
                        <div >{
                        paginas.length>0 && paginas.map(e=>
                              <button  className={s.paginado} onClick={()=> numberBotton(e)}>{ e }</button>
                        )}
                        </div>  
                    }
                </nav>
            </div>
    )
}